import React, { useEffect } from 'react';
import { useApi } from '@sdir/httpclient/lib/hooks/useApi';
// eslint-disable-next-line max-len
import { EndorsementServiceFeaturesGetCertificateAuthoritiesAvailableCertificateAuthoritiesDto as AuthoritiesDto } from '@sdir/httpclient/lib/clients/aps/endorsement';
import { endorsementApi } from '../../httpclient';
import { asLoadable } from '../../types';
import { AuthoritiesContext } from '../../services/contexts/AuthoritiesContext';

interface AuthoritiesProviderProps {
  children?: any;
}

export const AuthoritiesProvider: React.FC<AuthoritiesProviderProps> = ({ children }) => {
  const {
    result: authorities,
    errorObject: authoritiesError,
    loading: authoritiesLoading,
    callApi: getAuthorities,
  } = useApi({
    apiFunction: () => endorsementApi.getAvailableCertificateAuthorities(),
  });

  useEffect(() => {
    if (!authoritiesLoading && !authoritiesError && !authorities) getAuthorities();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authoritiesLoading]);

  const value = asLoadable<AuthoritiesDto[]>(authorities, authoritiesError, authoritiesLoading);

  return <AuthoritiesContext.Provider value={value}> {children} </AuthoritiesContext.Provider>;
};
